import {
  collection,
  doc,
  getDocs,
  setDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from '../config';

// Migration to consolidate features into a single collection
export const migrateFeatures = async () => {
  try {
    const newFeatures = new Map();
    const featuresCollection = collection(db, 'features');

    // Get all system features
    const systemFeaturesRef = collection(db, 'system_features');
    const systemSnapshot = await getDocs(systemFeaturesRef);
    
    // Process system features
    systemSnapshot.forEach((docSnap) => {
      const data = docSnap.data();
      newFeatures.set(docSnap.id, {
        id: docSnap.id,
        label: data.label,
        source: data.autoDetected ? 'auto' : 'system',
        confidence: data.confidence || null,
        createdAt: data.createdAt || serverTimestamp(),
        updatedAt: serverTimestamp()
      });
    });

    // Get all custom features
    const customFeaturesRef = collection(db, 'custom_features');
    const customSnapshot = await getDocs(customFeaturesRef);
    
    // Process custom features
    customSnapshot.forEach((docSnap) => {
      const data = docSnap.data();
      if (!newFeatures.has(docSnap.id)) {
        newFeatures.set(docSnap.id, {
          id: docSnap.id,
          label: data.label,
          source: 'manual',
          confidence: null,
          createdAt: data.createdAt || serverTimestamp(),
          updatedAt: serverTimestamp()
        });
      }
    });

    // Get auto-detection mappings
    const mappingsRef = collection(db, 'auto_detect_mappings');
    const mappingsSnapshot = await getDocs(mappingsRef);
    
    // Process auto-detection mappings
    mappingsSnapshot.forEach((docSnap) => {
      const data = docSnap.data();
      const featureId = data.modelClass.toLowerCase().replace(/\s+/g, '-');
      
      // Only add if not already exists
      if (!newFeatures.has(featureId)) {
        newFeatures.set(featureId, {
          id: featureId,
          label: data.modelClass,
          source: 'auto',
          confidence: null,
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp()
        });
      }
    });

    // Save all features to new collection
    for (const [id, feature] of newFeatures) {
      await setDoc(doc(featuresCollection, id), feature);
    }

    console.log(`Migrated ${newFeatures.size} features to new collection`);
    return { success: true };
  } catch (error) {
    console.error('Error migrating features:', error);
    return { success: false, error: error.message };
  }
};
